import { render, staticRenderFns } from "./DriversExpenses.vue?vue&type=template&id=4e57e122&scoped=true&"
import script from "./DriversExpenses.vue?vue&type=script&lang=js&"
export * from "./DriversExpenses.vue?vue&type=script&lang=js&"
import style0 from "./DriversExpenses.vue?vue&type=style&index=0&id=4e57e122&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e57e122",
  null
  
)

export default component.exports